import { RoutePage } from './../../../../app-routes.enum';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-progress-snack',
    templateUrl: './progress-snack.component.html',
    styleUrls: ['./progress-snack.component.scss'],
    standalone: false
})
export class ProgressSnackComponent {

  constructor(private router: Router) {}

  @Input() message: string;
  @Input() progress: number = 0;
  @Input() isCompleted: boolean = false;
  @Input() reportId: string = "";
  @Input() isPageActive: boolean = true;
  @Output() public closePressed: EventEmitter<boolean> = new EventEmitter<boolean>();

  onOpenClicked() {
    this.router.navigate([RoutePage.InspectionReport, this.reportId]);
    this.closePressed.emit(true);
  }

  onClose() {
    this.closePressed.emit(true);
  }
}
